import styled from 'styled-components'
import { PageHeader } from '../styled'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`

export const Header = styled(PageHeader)`
  text-align: left;
`
